import { InputAdornment } from "@mui/material";
import TextField from "../text-field/text-field";
import ColorLensIcon from '@mui/icons-material/ColorLens';
import _ from "lodash";
import React from "react";

const ColorPickerInput = ({value, onChange, label, ...props}) => {

   // Debounced function to update text
   const debouncedSetColor = (
    _.debounce((value) => {
      onChange(value)
    }, 500)
  );

  const handleColorChange = (e) => {
    debouncedSetColor(e.target.value);
  };

  return (
    <TextField
            label={label || ''}
            variant='outlined'
            type="color"
            value={value}
            onChange={handleColorChange}
            size="small"
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <ColorLensIcon fontSize="small" />
                </InputAdornment>
              ),
            }}
            {...props}
          />
  );
}
 
export { ColorPickerInput };
export default ColorPickerInput;